import React, { useEffect, useRef, useState } from "react";
import { doRequest, fonts, isNewFont } from "../utils/helper";
import { config } from "../utils/config";
import GenerateFontFaces from "./GenerateFontFaces";
import { addGlobalFont } from "polotno/config";
import SpinnerLoader from "../page/private/PolotnoDesign/SpinnerLoader";
import { trackAnalyticsEvent } from "../utils/analytics";

export default function TeedexFontsComponant({
  selected,
  onSelect,
  selectedObject,
  playerDetail,
  searchQuery,
  store,
  onMouseEnter,
  onMouseLeave,
  setSelectedFont,
  setOriginalFont,
  setIsFirstHover,
  fontsList,
  loading,
  previewFontSize
}) {
  const element = store.selectedElements[0];
  const [filteredFonts, setFilteredFonts] = useState([]);

  const [selectedIndex1, setSelectedIndex1] = useState(null);
  const fontListRef = useRef([]);

  const changeFontByIndex = (index, enter) => {
    const sFont = filteredFonts[index];
    if (sFont) {
      element?.set({ fontFamily: sFont.name });
      fontListRef.current[index]?.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
      if (enter) {
        setSelectedFont(sFont.name);
      }
    }
  };

  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = GenerateFontFaces(fonts);
    document.head.appendChild(styleSheet);
  }, []);

  useEffect(() => {
    const handleArrowNavigation = (e) => {
      if (loading || filteredFonts.length === 0) return;
      let defaultIndex = filteredFonts.findIndex(
        (font) => font.name === store.selectedElements[0]?.fontFamily
      );
      let indexinside;
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setSelectedIndex1((prev) => {
          const nextIndex = Math.min(
            filteredFonts.length - 1,
            (prev ? prev : defaultIndex) + 1
          );
          changeFontByIndex(nextIndex);
          indexinside = nextIndex;
          return nextIndex;
        });
      }

      if (e.key === "ArrowUp") {
        e.preventDefault();
        setSelectedIndex1((prev) => {
          const nextIndex = Math.max(0, (prev ? prev : defaultIndex) - 1);
          changeFontByIndex(nextIndex);
          indexinside = nextIndex;
          return nextIndex;
        });
      }


      // if (e.key === "Enter") {
      //   e.preventDefault();
      //   changeFontByIndex(indexinside, "enter"); // ✅ Call your function with the active index
      // }
    };

    document.addEventListener("keydown", handleArrowNavigation);
    return () => document.removeEventListener("keydown", handleArrowNavigation);
  }, [filteredFonts, loading]);

  // useEffect(() => {
  //   const filtered = fontsList.filter((font) =>
  //     font.name.toLowerCase().includes(searchQuery.toLowerCase())
  //   );
  //   setFilteredFonts(filtered);
  // }, [searchQuery, fontsList]);

  useEffect(() => {
    const filtered = fontsList
      .filter((font) =>
        font.name.toLowerCase().includes(searchQuery.toLowerCase())
      )
      .sort((a, b) => {
        const aIsNew = isNewFont(a.created_at);
        const bIsNew = isNewFont(b.created_at);
  
        // NEW fonts first
        if (aIsNew && !bIsNew) return -1;
        if (!aIsNew && bIsNew) return 1;
  
        // Keep existing order
        return a.sequence - b.sequence;
      });
  
    setFilteredFonts(filtered);
  }, [searchQuery, fontsList]);

  const handleFontClick = (fontName, fontInfo = null) => {

    // Apply the font permanently when clicked
    element?.set({ fontFamily: fontName });
    setSelectedFont(fontName);
    setOriginalFont(fontName); // Update the original font to the newly selected font
    setIsFirstHover(false); // Set first hover to false when user clicks
    // setSelectedFontInfo(fontInfo);

    store.set({
      fonts: [
        {
          fontFamily: fontName,
          url: fontInfo.url      
        }
      ]
    }); 

    trackAnalyticsEvent("design_font_selected", {
      font_name: fontName,
      font_source: "teedex",
    });
    
    element?.canvas?.requestRenderAll();
    
  
  };

  const handleMouseEnter = (fontName) => {
    // Set first hover to false on first interaction
    setIsFirstHover(false);
    onMouseEnter(fontName);
  };


  return (
    <>
      <div className="font_pos">
        <ul className="options option_font">
          {loading ? (
            <SpinnerLoader loading={loading} />
          ) : filteredFonts.length > 0 ? (
            filteredFonts.map((option, index) => (
              <li
                ref={(el) => (fontListRef.current[index] = el)}
                key={index}
                onClick={() => handleFontClick(option.name, option)}
                onMouseEnter={() => handleMouseEnter(option.name)}
                onMouseLeave={() => onMouseLeave()}
                role="option"
                aria-selected={
                  store.selectedElements[0]?.fontFamily === option.name
                }
              >
                <ul style={{ cursor: "pointer" }}>
                  <li
                    className={
                      store.selectedElements[0]?.fontFamily === option.name
                        ? "selectedFont"
                        : "fontlisthover"
                    }
                  >
                    <sup >
                      {option.name}
                      {isNewFont(option.created_at) && (
                        <span className="new-font-label"> NEW</span>
                      )}
                    </sup>
                    <span>
                      <p style={{ fontFamily: option.name, fontSize: `${previewFontSize}px`, }}>
                        {store.selectedElements[0]?.text}
                      </p>
                    </span>
                  </li>
                </ul>
              </li>
            ))
          ) : (
            <p>No fonts found</p>
          )}
        </ul>
      </div>
    </>
  );
}
